import React from 'react';

import PropTypes from 'prop-types';
import { MdClear } from 'react-icons/md';

const ToastCloseButton = ({ onClick }) => (
  <MdClear className="toast-close-icon" onClick={onClick} />
);

ToastCloseButton.defaultProps = {
  onClick: () => {},
};

ToastCloseButton.propTypes = {
  onClick: PropTypes.func,
};

export default ToastCloseButton;
